module.exports = __webpack_public_path__ + "img/integrity.b858a7d6.svg";